import React from 'react';

export function AtualizacaoPerfil({ modalData }) {
  return (
    <div>
      {modalData?.responsavel?.nomeFantasia ? (
        <p>
          <b>Instituição: </b> {modalData?.responsavel?.nomeFantasia}
        </p>
      ) : (
        ''
      )}

      {modalData?.responsavel?.email ? (
        <p>
          <b>Responsável: </b> {modalData?.responsavel?.email}
        </p>
      ) : (
        ''
      )}
    </div>
  );
}
